import {Snackbar} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useUser from 'components/GenericsHooks/useUser';
import {Loading} from 'components/grid-dx/loading/loading';
import {i18n2} from 'features/i18n/i18n';
import {Form, Formik} from 'formik';
import React from 'react';
import {Redirect} from 'react-router-dom';
import Signature from '../Editors/Signature';

function PopupRemove({
  initialValues,
  open,
  setOpen,
  row = null,
  commitDeleted = null,
  dataRedirect = null,
  promiseToReturn = null,
  types = null,
  url = null,
  redirect,
  setRedirect,
  text = null,
  title = null,
  customPadding = null,
  CustomFields = null,
  dispatch = null,
  actionType = null,
  withMessage = true,
}: any) {
  const [message, setMessage] = React.useState({
    text: '',
    open: false,
    succesful: false,
  });
  const [loading, setLoading] = React.useState(false);

  const submit = (values: any, {setFieldValue, setSubmitting}: any) => {
    setLoading(true);
    if (dispatch != null && actionType != null) {
      dispatch({type: actionType, payload: true});
    }
    values = {
      ...values,
      user: userName,
    };
    if (commitDeleted != null && row != null) {
      commitDeleted(
        values,
        row,
        () => {
          setMessage({
            text: i18n2._('Borrado exitosamente'),
            open: true,
            succesful: true,
          });
        },
        () => {
          setSubmitting(false);
        },
      );
    } else if (types != null && promiseToReturn != null) {
      if (types.AddedThree == null) {
        types.AddedTwo = values;
      } else {
        types.AddedThree = values;
      }
      return promiseToReturn(types)
        .then((response: any) => {
          if (response.ok) {
            if (withMessage) {
              setMessage({
                text: i18n2._('Operación terminada exitosamente'),
                open: true,
                succesful: true,
              });
            } else {
              response.text().then((message: any) => {
                const successMessage =
                  message && message.trim().length > 0
                    ? message
                    : i18n2._('Operación terminada exitosamente');
                setMessage({text: successMessage, open: true, succesful: true});
              });
            }
          } else {
            response.text().then((message: any) => {
              setFieldValue('pass', '');
              setMessage({text: message, open: true, succesful: false});
              setLoading(false);
            });
          }
        })
        .catch((error: any) => console.log(error));
    }
  };

  const userName = useUser();

  const close = () => {
    setMessage({...message, open: false});
    setLoading(false);
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open}>
        <DialogTitle id="draggable-dialog-title">
          {title ? title : i18n2._(`Confirm operation`)}
        </DialogTitle>
        <DialogContent style={{paddingLeft: '4%', marginBottom: 0}}>
          {text}
        </DialogContent>
        <Formik
          initialValues={{
            ...initialValues,
          }}
          onSubmit={submit}
          validateOnChange
          enableReinitialize>
          {({errors, touched, isSubmitting}) => (
            <Form style={{padding: 15}}>
              {CustomFields && CustomFields(errors, touched)}
              <Signature
                user={userName}
                customPadding={customPadding ? customPadding : null}
                errors={errors}
                touched={touched}
              />
              <DialogActions>
                <Button
                  autoFocus
                  onClick={() => setOpen(false)}
                  className="red-text">
                  {i18n2._('Cancel')}
                </Button>
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {i18n2._('Accept')}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
        {loading && <Loading />}
      </Dialog>
      {redirect && <Redirect to={{pathname: url, state: dataRedirect}} />}
      <Snackbar
        open={message.open}
        autoHideDuration={4500}
        onClose={() =>
          message.succesful
            ? url
              ? setRedirect(true)
              : close()
            : setMessage({...message, open: false})
        }
        message={i18n2._(message.text ? message.text : '')}
      />
    </>
  );
}

export default PopupRemove;
